"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteProduct = deleteProduct;
async function deleteProduct(productRepo, id) {
    return await productRepo.deleteProduct(id);
}
